import { ShapeSponsorshipLevel } from '@lopo-tech/lopo-api'
import { IAvatarBadge } from 'src/components/avatar/avatar'
import { COLOR_TYPE_WHITE, COLOR_TYPE_SECONDARY4, COLOR_TYPE_PRIMARY } from 'src/utils/color'

const sponsorBadges: Record<ShapeSponsorshipLevel, IAvatarBadge> = {
  [ShapeSponsorshipLevel.Bronze]: {
    backgroundColor: COLOR_TYPE_WHITE,
    borderColor: COLOR_TYPE_WHITE,
    icon: 'lopo-inverted-round',
    iconColor: COLOR_TYPE_PRIMARY
  },
  [ShapeSponsorshipLevel.Silver]: {
    backgroundColor: COLOR_TYPE_WHITE,
    borderColor: COLOR_TYPE_WHITE,
    icon: 'lopo-inverted-round',
    iconColor: COLOR_TYPE_SECONDARY4
  }
}

export const getSponsorBadge = (sponsorLevel: ShapeSponsorshipLevel) => {
  return sponsorBadges[sponsorLevel]
}
